export default {
    login: {
        email: 'Courriel',
        password: 'Mot de passe',
        remember: 'Se souvenir de moi',
        connect: 'Connexion',
        forgotPassword: 'Mot de passe oublié?',
        failed: 'Identifiants invalides.',
        connectToAccount: 'Connectez-vous à votre compte',
        error: 'Une erreur inconnue est survenue. Veuillez réessayer.',
    },
    twoFactorChallenge: {
        pageTitle: 'Identification à deux facteurs',
        instructions: "Un code de vérification a été généré dans votre gestionnaire d'authentification. Veuillez entrer ce code pour continuer.",
        invalidCode: 'Code de vérification invalide.',
        verificationCode: 'Code de vérification',
        validate: 'Valider',
        useRecoveryCode: 'Utiliser un code de récupération',
        useOneTimePassword: 'Utiliser un code à usage unique',
    },
    twoFactorSetup: {
        pageTitle: "Configuration de l'identification à deux facteurs",
        instructions: "L'identification à deux facteurs est nécessaire pour assurer un accès sécuritaire au gestionnaire de licences.",
        activate: 'Configurer maintenant',
        later: 'Plus tard',
        modal: {
            title: 'Identification à deux facteurs',
            instructions: "Scanner le code QR ci-dessus à l'aide d'une application d'authentification telle que Google Authenticator.",
            activation: 'Activation',
            recoveryCodes: 'Codes de récupération',
            button: "Terminer l'activation",
        },
    },
    forgotPassword: {
        pageTitle: 'Mot de passe oublié',
        email: 'Courriel',
        instructions: 'Entrez le courriel associé au compte pour lequel vous souhaitez réinitialiser le mot de passe.',
        send: 'Envoyer',
        userNotFound: 'Ce courriel n\'est associé à aucun utilisateur.',
        invalidEmail: 'Le courriel saisi n\'est pas valide.',
        unknownError: 'Une erreur inconnue est survenue.',
        emailSentTitle: 'Courriel envoyé',
        emailSentText: 'Un courriel de réinitialisation de mot de passe a été envoyé à votre adresse courriel.',
        passwordFound: 'Vous avez retrouvé votre mot de passe?',
    },
    newPassword: {
        pageTitle: 'Nouveau de mot de passe',
        instructions: 'Vous avez presque terminé! Veuillez entrer un nouveau mot de passe (minimum 8 caractères).',
        password: 'Mot de passe',
        passwordConfirmation: 'Confirmez le mot de passe',
        changePassword: 'Changer le mot de passe',
        passwordChanged: 'Le mot de passe a été changé avec succès.',
    },
    forceNewPassword: {
        pageTitle: 'Définissez votre mot de passe',
        instructions: 'Un mot de passe temporaire vous a été fourni pour accéder au générateur de licences pour la première fois. Veuillez entrer un nouveau mot de passe qui sera utilisé pour les connexions subséquentes (minimum 8 caractères).',
        currentPassword: 'Mot de passe temporaire',
        password: 'Nouveau mot de passe',
        passwordConfirmation: 'Confirmez le mot de passe',
        changePassword: 'Sauvegarder',
        passwordChanged: 'Le mot de passe a été changé avec succès.',
        errors: {
            currentPassword: 'Le mot de passe temporaire est invalide.',
            passwordConfirmation: 'Le mot de passe et la confirmation de mot de passe ne correspondent pas.',
        },
    },
};
